export default {
  addSkipper(state, payload) {
    state.skippers.push(payload);
  },

  setSkippers(state, payload) {
    state.skippers = payload;
  },
  setFetchTimestamp(state) {
    state.lastFetch = new Date().getTime();
  }
};
